module.exports = __webpack_public_path__ + "static/img/close-dark.20d2f8ff.svg";